function callAPI(apiResponseDiv) {
    const apiUrl = 'http://Anti.fwdby.com/Mobile/AntiFunc';
    const userInput = document.getElementById('textInput').value;
    const parameters = {
    Code: userInput
    ,IP: '113.105.64.74'
    };

    // Construct the query string from parameters object
    const queryString = Object.keys(parameters)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]))
    .join('&');

    // Append the query string to the API URL
    const urlWithParams = apiUrl + '?' + queryString;

    // Make the API call when the button is clicked
    fetch(urlWithParams)
    .then(response => {
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Handle the response data
        // Clear previous content in the specified div
        apiResponseDiv.innerHTML = '';
        Object.keys(data).forEach(key => {
            const paragraph = document.createElement('p');
            paragraph.textContent = `${key}: ${data[key]}`;
            apiResponseDiv.appendChild(paragraph);
          });
    })
    .catch(error => {
        // Handle errors
        apiResponseDiv.textContent = 'Error fetching data. Please try again.';
    });
}